import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  Text,
  ButtonGroup,
  Button,
  Modal,
  TextField,
  Select,
  BlockStack,
  InlineStack,
  Box,
  Spinner,
  FormLayout,
  Image,
  Link,
  Divider,
  Tag,
  Toast,
  TextContainer,
  Icon,
  Badge,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import MyPagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import {
  CategoriesIcon,
  EditIcon,
  ImagesIcon,
  LinkIcon,
  PlusCircleIcon,
} from "@shopify/polaris-icons";
import countries from "../../../Data/countries.json";
import lebanonIcon from "../../../Assets/Images/lb.svg";
import iraqIcon from "../../../Assets/Images/iq.svg";
import egyptIcon from "../../../Assets/Images/eg.svg";

const TaskManagerProjects = () => {
  const navigate = useNavigate();

  // Filters state
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [countryFilter, setCountryFilter] = useState("All");
  const [timeline, setTimeline] = useState("All");
  const timelineButtons = [
    { label: "All", value: "All" },
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
  ];

  // Data state
  const [items, setItems] = useState(null);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 50;
  const refBoolPage = useRef(true);
  const [activeShow, setActiveShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Toast
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive(!active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  // Modal Delete
  const [activeDelete, setActiveDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);

  const handleChangeModalShow = useCallback(() => {
    setActiveShow(!activeShow);
  }, [activeShow]);

  const handleChangeModalDelete = useCallback(() => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, [activeDelete]);

  const handleRowClick = (id) => {
    navigate(`/admin/task-manager/projects/${id}/tasks`);
    //setCurrentIndex(index);
    //setActiveShow(true);
  };

  const handleAddItem = () => {
    navigate("/admin/task-manager/projects/new");
  };

  const handleEdit = (id) => {
    navigate(`/admin/task-manager/projects/${id}`);
  };

  const handleScreenshots = (id) => {
    navigate(`/admin/projects/${id}/screenshots`);
  };

  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [country, setCountry] = useState("");

  useEffect(() => {
    fetchData();
  }, [page, search, countryFilter, statusFilter, country]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);
      if (search) params.append("filter[title]", search);
      if (statusFilter !== "All") params.append("filter[type]", statusFilter);

      if (country !== "") params.append("filter[country]", country);
      // if (countryFilter !== "All")
      //   params.append("filter[location]", countryFilter);

      const response = await axios.get(`/task-manager-projects`);
      const data = response.data.data.data;

      console.log("data=", data);
      data.length &&
        navigate(`/admin/task-manager/projects/${data[0].id}/tasks`);
      // setResult(data);
      setItems(data);

      // setTotalPages(response.data.data.total);
      // setIsListEmpty(!data.length);
    } catch (err) {
      console.error(err);
      setIsListEmpty(true);
    }
    setIsLoading(false);
  };

  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage} />
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
    </div>
  ) : isLoading ? (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  ) : null;
  const [countryButtons, setCountryButtons] = useState([]);
  // useEffect(() => {
  //   axios
  //     .get("/settings/countries")
  //     .then((res) => {
  //       const countriesData = res?.data?.data || [];
  //       const options = [
  //         { label: "All", value: "" },
  //         { label: "Mutual", value: "All" },
  //         ...countriesData.map((country) => ({
  //           label: country.name,
  //           value: country.name,
  //           flag: country.flag,
  //         })),
  //       ];
  //       setCountryButtons(options);
  //       // setCountry(options?.[0]);
  //     })
  //     .catch((err) => console.log(err));
  // }, []);
  return items ? (
    <Page
      title="Projects"
      // primaryAction={
      //   <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
      //     Add Project
      //   </Button>
      // }
      // secondaryActions={
      //   <Button
      //     onClick={() => navigate("/admin/projects/edit/categories")}
      //     icon={CategoriesIcon}
      //   >
      //     Categories
      //   </Button>
      // }
      fullWidth
    >
      <Card>
        <div
          style={{
            display: "flex",
            justifyContent: "middle",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: "25%" }}>
            <img src={emptyListImage}></img>
          </div>
          <div className="mb-3">
            <Button
              variant="primary"
              onClick={handleAddItem}
              icon={PlusCircleIcon}
            >
              Add Project
            </Button>
          </div>
          <br />
        </div>
      </Card>
    </Page>
  ) : (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spinner size="large" />
    </div>
  );
};

export default TaskManagerProjects;
